import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const GradientButton = styled(Button)(({ theme, textTransformtype }) => ({
  color: theme.palette.common.black,
  fontWeight:700,
  textTransform:textTransformtype?textTransformtype:'uppercase',
  borderRadius:"0.75rem",
  paddingLeft:"1rem",
  paddingRight:"1rem",
  transition:`all ${theme.transitions.duration.standard} ${theme.transitions.easing.easeInOut}`,
  backgroundImage: `linear-gradient(180deg, #8dd5ac 0%, #dbefdb 100%);`,
  '&:hover': {
    backgroundPosition:"200%"
    //backgroundColor: purple[700],
  }
}));